import ChevronIcon from "./ChevronIcon";

export default function ChevronButton({
  onClick,
  direction,
  extraStyles,
}: {
  onClick: () => void;
  direction?: "left" | "right";
  extraStyles?: string;
}) {
  return (
    <button
      name={direction}
      data-testid={direction}
      onClick={onClick}
      className={`py-2.5 px-3 text-sm transition-colors duration-300 ease-in-out ${extraStyles} rounded ${
        direction === "right" ? "rotate-180" : ""
      } hover:bg-gray-100`}
    >
      <ChevronIcon />
    </button>
  );
}
